import { FEATURE_FLAG } from '~/constants/featureFlags';

import { type RouteExportParams } from '~/types/router.type';

export const routeParams: RouteExportParams = {
  featureFlag: FEATURE_FLAG.BUSINESS_PARTNER_SETTINGS,
};
